
import { FC, useEffect, useState } from "react";
import { OrderFindedType } from "../../pages/SearchOrders";
import './index.css'
import box from '../../assets/images/box.svg'
import check from '../../assets/images/check.svg'
import canceled from '../../assets/images/circle-xmark.svg'
import { useNavigate } from "react-router-dom";
import { floatToPrice } from "../../functions/price_functions";

type OrderItem = {
    order: OrderFindedType
}

type status = {
    content: string
    icon: any
    color: string
}

const OrderItem: FC<OrderItem> = ({ order }) => {

    const navigate = useNavigate()
    const [status, setStatus] = useState<status>({
        color: '',
        content: '',
        icon: ''
    })

    const getStatus = () => {
        try {
            const auxStatus = order.status[0]
            const back: any = auxStatus.colorSetting


            const status = {
                icon: '',
                content: '',
                color: ''
            }

            if (auxStatus.slug === 'a') {
                status.content = 'Cancelado: o pedido foi cancelado.'
                status.color = back.background ? back.background : '#EB5353'
                status.icon = canceled
            } else if (auxStatus.slug === 'b') {

                status.content = 'Concluído: o pedido foi entregue.'
                status.color = back.background ? back.background : '#67BF5F'
                status.icon = check
            } else {
                status.content = 'Em preparo: seu pedido está sendo preparado.'
                status.color = back.background ? back.background : '#40A7E0'
                status.icon = box
            }


            setStatus(status)

        } catch (error) {
            return error
        }

    }

    const details = (orderExt: string) => {

        navigate(orderExt)
    }


    useEffect(() => {
        getStatus()
    }, [])



    return (
        <div className="myOrderItemContent">
            <div className="info">
                <div className="header">
                    <h3>Pedido {order.id}</h3>
                    <span className="data">Realizado em {order.date} </span>
                    <span className="valor">{floatToPrice(order.totalValue)}</span>
                </div>
                <div>
                    <button className="butttonInfo" onClick={() => details(order.ext)}> Detalhes {'→'} </button>
                </div>
            </div>

            <div className="status" style={{ backgroundColor: status.color }}>
                <img src={status.icon} alt="" />
                <span>

                    {
                        status.content
                    }</span>
            </div>
        </div>
    )
}


export { OrderItem }